import {
  digitPattern,
  lowercasePattern,
  specialCharactersPattern,
  uppercasePattern
} from '@anm/helpers/is/isValidPassword';

export const PASSWORD_CHECK_LIST = [
  {
    label: 'At least 8 characters',
    pattern: /.{8,}/
  },
  {
    label: 'One upper case',
    pattern: uppercasePattern
  },

  {
    label: 'One lower case',
    pattern: lowercasePattern
  },

  {
    label: 'One number',
    pattern: digitPattern
  },
  {
    label: 'One special character',
    pattern: specialCharactersPattern
  }
];